import { gql } from 'graphql-request';

export default gql`
  query Query($mask: String, $id: String) {
    directoryById(mask: $mask, id: $id) {
      id
      account_id
      doc
      listing
    }
  }
`;
